import { render, staticRenderFns } from "./salary-settype-dialog.vue?vue&type=template&id=4888c430&scoped=true&"
import script from "./salary-settype-dialog.vue?vue&type=script&lang=js&"
export * from "./salary-settype-dialog.vue?vue&type=script&lang=js&"
import style0 from "./salary-settype-dialog.vue?vue&type=style&index=0&id=4888c430&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4888c430",
  null
  
)

export default component.exports